import script from "./AnalyticsTopTable.vue?vue&type=script&setup=true&lang=js"
export * from "./AnalyticsTopTable.vue?vue&type=script&setup=true&lang=js"

import "./AnalyticsTopTable.vue?vue&type=style&index=0&id=079a17d4&lang=scss"

const __exports__ = script;

export default __exports__